/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import Header from './ToolsHeader';
import { Button, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => createStyles({
  root: {
    minHeight: '100vh',
    // backgroundColor: '#000A16',
    color: theme.palette.common.white,
    fontFamily: 'Roboto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // '& iframe': {
    //   '& .widgetHome': {
    //   }
    // },
  },
  contentWrapper: {
    padding: '10px 100px',
    backgroundColor: '#F4F4F4',
    height: '100%',
    flexGrow: 1,
    '& iframe': {
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '4px',
    },
  }
})
);

const BoardToken = 'a9dc779d-a938-5fa1-0421-004b6665eb31';

const Feedback = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header>
      </Header>
      <div data-canny changelog className={classes.contentWrapper}>
      <Button variant='outlined' data-canny-changelog>View Changelog</Button>
      </div>
    </div>
  );
}

export default Feedback;